import './App.css';
import { BrowserRouter as Router, Route} from "react-router-dom";

import SmashBuzzBar from './components/SmashBuzzBar';
import TourneyTable from './components/TourneyTable';
import TourneyChart from './components/TourneyChart';
import TourneyCardList from './components/TourneyCardList';
import Footer from './components/Footer';
import Home from './components/Home';

function App() {
  return (
    <div className="App">
      <div style={{ minHeight: "calc(100vh - 100px)"}}>
        <Router>
          <SmashBuzzBar/>
          <div style={{padding:'5%'}}>
            <Route path="/" exact component={Home} />
            <Route path="/Tournaments" component={TourneyTable} />
            <Route path="/Chart" component={TourneyChart} />
            <Route path="/CardList" component={TourneyCardList} />
          </div>
        </Router>
      </div>
      <div>
        <Footer/>
      </div>
    </div>
  );
}

export default App;
